import { Col, Row } from 'react-bootstrap';

import {
  Content,
  Layout,
  Stack,
} from 'apps/dashboard/shared/scripts/components';

import AccountSettingsFormContainer from '../AccountSettingsFormContainer';
import SecuritySettingsFormContainer from '../SecuritySettingsFormContainer';

import messages from './messages.json';

const SettingsContainer = () => {
  return (
    <Layout>
      <Content title={messages.settingsTitle}>
        <Row>
          <Col md={8}>
            <Stack>
              <AccountSettingsFormContainer />
              <SecuritySettingsFormContainer />
            </Stack>
          </Col>
        </Row>
      </Content>
    </Layout>
  );
};

SettingsContainer.displayName = 'SettingsContainer';

export default SettingsContainer;
